import apiClient from './client';
import { API_ROUTES } from './routes';
import { getAttribution } from '../utils/attribution';

export const authService = {
  async login(email, password) {
    const response = await apiClient.post(API_ROUTES.AUTH.LOGIN, {
      email,
      password,
      platform: 'web',
    });
    return response.data;
  },

  async signup({ email, password, firstName, lastName, phoneNumber }) {
    // Convert camelCase to snake_case for backend API
    const response = await apiClient.post(API_ROUTES.AUTH.SIGNUP, {
      email,
      password,
      first_name: firstName,
      last_name: lastName,
      phone_number: phoneNumber || null,
      platform: 'web',
      attribution: getAttribution(),
    });
    return response.data;
  },

  async googleAuth(accessToken) {
    const response = await apiClient.post(API_ROUTES.AUTH.GOOGLE, {
      access_token: accessToken,
      platform: 'web',
      attribution: getAttribution(),
    });
    return response.data;
  },

  async refreshToken(refreshToken) {
    const response = await apiClient.post(API_ROUTES.AUTH.REFRESH, {
      refresh_token: refreshToken,
    });
    return response.data;
  },

  async logout() {
    try {
      await apiClient.post(API_ROUTES.AUTH.LOGOUT);
    } catch (error) {
      // Logout is mostly client-side for JWT
      console.error('Logout error:', error);
    } finally {
      // Clear local storage
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
    }
  },
};
